import React, { useState } from 'react';
import './Modal.css';

function CloseIcon() {
  return <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
}

const MODALS = {
  'add-contact': AddContactModal,
  'add-deal':    AddDealModal,
  'view-contact': ViewContactModal,
  'add-event':   AddEventModal,
};

export default function Modal({ modal, onClose }) {
  const ModalComponent = MODALS[modal.type];
  if (!ModalComponent) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <ModalComponent data={modal.data} onClose={onClose} />
      </div>
    </div>
  );
}

function Field({ label, type = 'text', placeholder, options }) {
  return (
    <div className="modal-field">
      <label className="modal-label">{label}</label>
      {options
        ? <select className="modal-input"><option value="">Select {label}...</option>{options.map(o => <option key={o}>{o}</option>)}</select>
        : <input type={type} placeholder={placeholder || label} className="modal-input" />
      }
    </div>
  );
}

function AddContactModal({ onClose }) {
  return (
    <>
      <div className="modal-header">
        <h2>Add contact</h2>
        <button className="modal-close" onClick={onClose}><CloseIcon /></button>
      </div>
      <div className="modal-body">
        <div className="modal-row">
          <Field label="First name" placeholder="First name" />
          <Field label="Last name" placeholder="Last name" />
        </div>
        <Field label="Email" type="email" placeholder="email@example.com" />
        <Field label="Company" placeholder="Club or organisation" />
        <Field label="Job title" placeholder="Head of Scouting..." />
        <Field label="Contact type" options={['Club', 'Scout', 'Agent', 'Player']} />
        <Field label="Country" options={['United States', 'United Kingdom', 'Australia', 'Canada', 'Ireland', 'Spain', 'France', 'Germany', 'Italy', 'Brazil', 'Other']} />
        <Field label="Lead source" options={['Verified List', 'Paid Social', 'Referral', 'Organic', 'Influencer']} />
      </div>
      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={onClose}>Save contact</button>
      </div>
    </>
  );
}

function AddDealModal({ onClose }) {
  return (
    <>
      <div className="modal-header">
        <h2>Create deal</h2>
        <button className="modal-close" onClick={onClose}><CloseIcon /></button>
      </div>
      <div className="modal-body">
        <Field label="Deal name" placeholder="e.g. Arsenal FC — Club onboarding" />
        <Field label="Contact" placeholder="Search contact..." />
        <Field label="Stage" options={['Lead', 'Outreach Sent', 'Engaged', 'Onboarding', 'Onboarded', 'Activated']} />
        <Field label="Amount ($)" type="number" placeholder="0" />
        <Field label="Close date" type="date" />
        <Field label="Pipeline" options={['Club Pipeline', 'Scout Pipeline']} />
      </div>
      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={onClose}>Create deal</button>
      </div>
    </>
  );
}

function AddEventModal({ onClose }) {
  return (
    <>
      <div className="modal-header">
        <h2>Create event</h2>
        <button className="modal-close" onClick={onClose}><CloseIcon /></button>
      </div>
      <div className="modal-body">
        <Field label="Event title" placeholder="e.g. Scouting Showcase Lagos" />
        <Field label="Event type" options={['Scouting', 'Tournament', 'Training', 'Conference', 'Other']} />
        <Field label="Date" type="date" />
        <Field label="Location" placeholder="City, Country" />
        <Field label="Status" options={['Active', 'Pending', 'Cancelled']} />
        <div className="modal-field">
          <label className="modal-label">Description</label>
          <textarea className="modal-input" rows={3} placeholder="Event description..." style={{ resize: 'vertical', fontFamily: 'var(--font-body)' }} />
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={onClose}>Create event</button>
      </div>
    </>
  );
}

function ViewContactModal({ data, onClose }) {
  const c = data || { firstName: 'Alex', lastName: 'Aldridge', email: 'alex@coloradorapids.com', company: 'Colorado Rapids', type: 'Scout', country: 'United States', status: 'Activated' };
  return (
    <>
      <div className="modal-header">
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <div className="avatar" style={{ width:44, height:44, fontSize:15, background:'rgba(167,244,50,0.15)', color:'var(--accent)' }}>
            {c.firstName?.[0]}{c.lastName?.[0]}
          </div>
          <div>
            <h2 style={{ marginBottom:2 }}>{c.firstName} {c.lastName}</h2>
            <span style={{ fontSize:12, color:'var(--text-muted)' }}>{c.job || c.type}</span>
          </div>
        </div>
        <button className="modal-close" onClick={onClose}><CloseIcon /></button>
      </div>
      <div className="modal-body">
        <div className="view-table">
          {[['Email', c.email],['Company', c.company],['Type', c.type],['Country', c.country],['Status', c.status]].map(([k,v]) => (
            <div key={k} className="view-row">
              <span className="view-key">{k}</span>
              <span className="view-val">{v}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-ghost" onClick={onClose}>Close</button>
        <button className="btn btn-primary">Edit contact</button>
      </div>
    </>
  );
}
